import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentVm } from '../my-osk-student-vm.model';
import { IPaginatedResultMyOskStudentVm } from '../paginated-result-my-osk-student-vm.model';
import { SortOrder } from '../sort-order.model';
import { IMyOskStudentRemoveResultVm } from '../my-osk-student-remove-result-vm.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudents`;
  }
  get(archived: boolean, search: string, sortColumn: string, page?: number, pageSize?: number, sortOrder?: SortOrder): Observable<IPaginatedResultMyOskStudentVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (archived !== undefined && archived !== null) {
      params = params.set('archived', archived.toString());
    }
    if (search !== undefined && search !== null) {
      params = params.set('search', search.toString());
    }
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (sortColumn !== undefined && sortColumn !== null) {
      params = params.set('sortColumn', sortColumn.toString());
    }
    if (sortOrder !== undefined && sortOrder !== null) {
      params = params.set('sortOrder', JSON.stringify(sortOrder));
    }
    return this.http.get<IPaginatedResultMyOskStudentVm>(this.baseUrl, { headers, params });
  }
  delete(userAccountGuid: string): Observable<IMyOskStudentRemoveResultVm> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (userAccountGuid !== undefined && userAccountGuid !== null) {
      params = params.set('userAccountGuid', userAccountGuid.toString());
    }
    return this.http.delete<IMyOskStudentRemoveResultVm>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
